module.exports = __webpack_public_path__ + "img/background3-hk.384b59c8.jpg";